export default "/images/vendor/flag-icons/flags/1x1/sy.svg?475131156fa2b0e3d12420bc8f5483b0";